import Vue from 'vue';
import iView from 'iview';
import VueRouter from 'vue-router';
import {routers} from './router';
import getPageTitle from "@/api/get-page-title";
import { changeLanguage } from '@/util/locationutil.js'

Vue.use(VueRouter);
Vue.use(iView);
// 路由配置
const RouterConfig = {
    // mode: 'history',
    base: '/tch5/',
    routes: routers
};
export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {

    // 切换语言
    if (to.query && to.query.lang) {
        changeLanguage(to.query.lang)
    }

    // 设置标题
    document.title = getPageTitle(to.meta.title);
    // iView.LoadingBar.start();
    next();
});

router.afterEach((to) => {
    // iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});



// WEBPACK FOOTER //
// src/router/index.js